import React from 'react';
import { Link } from 'gatsby';
import { BASE_IMAGE_URI, formatCastMember } from '../../utils/helpers';

import './CastCard.scss';

import { ICrewMember } from '../../utils/models';
export interface CastCardProps {
  member: ICrewMember;
}
const CastCard = ({ member }: CastCardProps) => {
  const { name, characterName, personId, role } = member;
  // id comes back at 'person-12344' and we just want the numbers from the string
  const memberId = personId?.slice(7, personId.length);

  // role comes back from API in all uppercase format
  const formattedRole = `${role[0]}${role
    .slice(1, role.length)
    .toLocaleLowerCase()}`;

  const { name: formattedName } = formatCastMember(member);

  return (
    <>
      {/* Desktop */}
      <figure className="cast-card desktop">
        <Link
          to={`/cast/?name=${formattedName}`}
          aria-label={`View titles with ${name}`}
          className="cast-card__image-wrapper"
        >
          <img
            src={`${BASE_IMAGE_URI}/imageserver/person/${memberId}?width=191&default=true`}
            alt=""
            role="presentation"
            className="cast-card__image"
            width="191"
            height="284"
            loading="lazy"
          />
        </Link>
        <figcaption className="cast-card__caption">
          <span className="name">{name}</span>
          <span
            className="cast-card__role"
            aria-label={`as ${characterName ? characterName : formattedRole}`}
          >
            {characterName ? `as ${characterName}` : `${formattedRole}`}
          </span>
        </figcaption>
      </figure>

      {/* Mobile */}
      <Link
        to={`/cast/?name=${formattedName}`}
        aria-label={`View titles with ${name}`}
        className="cast-card__image-wrapper mobile"
      >
        <figure className="cast-card mobile">
          <img
            src={`${BASE_IMAGE_URI}/imageserver/person/${memberId}?width=191&default=true`}
            alt=""
            role="presentation"
            className="cast-card__image"
            width="191"
            height="284"
            loading="lazy"
          />
          <figcaption>
            <span className="name">{name}</span>
            <span
              className="cast-card__role"
              aria-label={`as ${characterName ? characterName : formattedRole}`}
            >
              {characterName ? `as ${characterName}` : `${formattedRole}`}
            </span>
          </figcaption>
        </figure>
      </Link>
    </>
  );
};

export default CastCard;
